import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/index';

@Component({
    selector: 'app-demo',
    templateUrl: './demo.component.html',
})
export class DemoComponent {
    clickOpenViewerPDF;

    constructor(private store: Store<AppState>) {}

    // getInfo() {
    //     this.dashboardService.getStage().subscribe(
    //         res => {
    //             console.log('getStage OK', res);
    //         },
    //         error => {
    //             console.log('getStage error ', error);
    //         }
    //     );
    // }
}
